<template>
    <app-layout>
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 ">
        
        <div class="grid grid-cols-3 gap-4">
          <div>
              <checkin></checkin>
          </div>

          <div>
          <AttendSummary></AttendSummary>
           
          </div>
          <!-- <TimingOverview></TimingOverview> -->

          <div>
          <!-- <AttendHistory></AttendHistory> -->
           <Leave></Leave>
          </div>
        </div>
        
      </div>
       
   </app-layout>
</template>

<script>
import Checkin from "./Component/Checkin.vue";
import AttendSummary from "./Component/AttendSummary.vue";
import TimingOverview from "./Component/TimingOverview.vue";
import Calender from "./Component/Calender.vue";
import AppLayout from "@/Layouts/AppLayout.vue";
import AttendHistory from "./Component/AttendHistory.vue";
import Leave from "./Component/Leave.vue";
export default {
  props: {
   
  },
  components: {
    Checkin,
    AppLayout,
    AttendSummary,
    TimingOverview,
    Calender,
    AttendHistory,
    Leave,
  },
}
</script>

<style>

</style>